import { Button, Grid2, MenuItem, Select, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { DirectionsRenderer, GoogleMap, Marker, useJsApiLoader, Polyline } from "@react-google-maps/api";
import routeMarker from '../../assets/images/routeMarker.svg';
import yellowRouteMarker from '../../assets/images/yellowRouteMarker.svg';
import greyRouteMarker from '../../assets/images/greyRouteMarker.svg';
// import vehicleTypeTruck from '../../assets/icons/truck.svg';
import pickupIcon from '../../assets/icons/PickupIcon.svg';
import dropIcon from '../../assets/icons/DropIcon.svg';
import connectAddress from '../../assets/images/connectAddress.svg';
import { useNavigate } from "react-router-dom";
import mapPin from '../../assets/icons/LocationPin.svg';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";
 
const LIBRARIES = ["maps", "drawing", "places", "geometry"];
var constants = require('../../constant');
 
const styles = {
    errorBox: {
      backgroundColor: '#EFFBF7',
      color: '#0DBA78',
      border: '1px solid #0DBA78',
      paddingLeft: '10%',
      paddingRight: '10%',
      borderRadius: '5px',
      marginTop: '6px'
    }
};
 
const ClockTower = () => {
 
    const serverUrl = config.serverUrl;
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
 
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [mapViewData, setMapViewData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [tokenExpired, setTokenExpired] = useState(false);
    const [selectedGrid, setSelectedGrid] = useState(null);
    const [gridClickData, setGridClickData] = useState(null);
    // Map center position - default to Bangalore
    const [center, setCenter] = useState({ lat: 12.9716, lng: 77.5946 });
    const [bluePath, setBluePath] = useState([]);
    const [showRoute, setShowRoute] = useState(false);
 
    const [mapLoaded, setMapLoaded] = useState(false);
    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
    }
 
    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }
 
    const { isLoaded } = useGoogleMapsLoader();
    const [map, setMap] = useState(null);
 
 
    const containerStyle = {
        width: '100%',
        height: '380px',
    };
    const containerStyleMain = {
        width: '100%',
        height: '550px',
    }
 
    const mapRef = useRef(null);
 
    const getControlTowerData = async() =>{
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/transport/fetch_control_tower_details";
            const obj={
                token: token,
                timestamp: timestamp,
                city_id: cityFilter
            }
            const response =  await makeGetRequestToUrl(url, obj);
 
 
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
 
            if(response.flag === 200){
                const mapViewData = response.data;
                setMapViewData(mapViewData);
                // Update map center to focus on first driver
                if (mapViewData && mapViewData.length > 0 && mapRef.current) {
                    const bounds = new window.google.maps.LatLngBounds();
                
                    mapViewData.forEach(({ driver_info }) => {
                        const lat = parseFloat(driver_info?.current_latitude);
                        const lng = parseFloat(driver_info?.current_longitude);
                
                        if (!isNaN(lat) && !isNaN(lng)) {
                            bounds.extend(new window.google.maps.LatLng(lat, lng));
                        }
                    });
                
                    if (!bounds.isEmpty()) {
                        // mapRef.current.fitBounds(bounds);
                        const map = mapRef.current;

                        // Fit map to bounds
                        map.fitBounds(bounds);

                        // Listen once for bounds change and adjust zoom if too close
                        const listener = window.google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
                            if (map.getZoom() > 11) {
                                map.setZoom(11);
                            }
                        });
                    }
                }
                
                // if (mapViewData && mapViewData.length > 0) {
                //     const first = mapViewData[0].driver_info;
                //     if (first?.current_latitude && first?.current_longitude) {
                //         setCenter({
                //             lat: Number(first.current_latitude),
                //             lng: Number(first.current_longitude)
                //         });
                //     }
                // }
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }
 
    useEffect(() => {
        getControlTowerData();
    },[cityFilter]);
 
    const onLoad = React.useCallback(function callback(map) {
        mapRef.current = map;
        setMap(map);
        setMapLoaded(true);
    }, []);
 
    const onUnmount = React.useCallback(function callback(map) {
        mapRef.current = null;
        setMap(null);
        setMapLoaded(false);
    }, []);
 
    // Build path when a grid item is clicked
    useEffect(() => {
        if (gridClickData?.trip_details) {
            const pickup = {
                lat: Number(gridClickData.trip_details.pickup_latitude),
                lng: Number(gridClickData.trip_details.pickup_longitude)
            };
            const drop = {
                lat: Number(gridClickData.trip_details.drop_latitude),
                lng: Number(gridClickData.trip_details.drop_longitude)
            };
            const path = [pickup, drop];
            setBluePath(path);
            setShowRoute(path.length > 1);
            if (path[0]) {
                setCenter({
                    lat: (Number(gridClickData.trip_details.pickup_latitude)+Number(gridClickData.trip_details.drop_latitude))/2,
                    lng: (Number(gridClickData.trip_details.pickup_longitude)+Number(gridClickData.trip_details.drop_longitude))/2
                });
            }
            // Fit bounds for pickup and drop
            if (mapRef.current && window.google) {
                const bounds = new window.google.maps.LatLngBounds();
                path.forEach(pt => bounds.extend(pt));
                mapRef.current.fitBounds(bounds);
            }
        } else {
            setShowRoute(false);
            setBluePath([]);
        }
    }, [gridClickData]);

    // When bluePath changes and map is ready, fit bounds so entire polyline is visible
    useEffect(() => {
        if (mapRef.current && bluePath.length > 1 && window.google) {
            const bounds = new window.google.maps.LatLngBounds();
            bluePath.forEach(pt => bounds.extend(pt));
            mapRef.current.fitBounds(bounds);
        }
    }, [bluePath]);

    const moveToDetails = (marker) => {
        console.log('marker=', marker);
        navigate('/clock-tower-details', {state: {marker: marker}});
    }
 
    return (
        <div>
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Control Tower</Typography>
 
            <Grid2 item container spacing={2} sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <Select
                        value={cityFilter}
                        onChange={handleCityChange}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
            </Grid2>
 
            <Grid2 item container size={12} spacing={2}>
                <Grid2 item size={4.2} sx={{ overflowY:'auto', maxHeight:'580px'}}>
                    {mapViewData &&  mapViewData.length>0 ? 
                        (mapViewData.map((marker, index) => (
                            <Grid2 item className="mainBox" sx={{marginTop:'4%',cursor: 'pointer',
                                border: selectedGrid===marker?.trip_details?.booking_id ? "1px solid #83888E": 'none',
                                boxShadow: selectedGrid===marker?.trip_details?.booking_id ? "2" : 'none'
                                }}
                                key={index} 
                                onClick={() => {
                                    setGridClickData(marker);
                                    setSelectedGrid(marker?.trip_details?.booking_id);
                                }}
                                >
                                <Grid2 item container>
                                    <Grid2 item size={9}>
                                        <Typography sx={{fontSize:'12px', color:'#83888E'}}>Booking ID </Typography>
                                        <Typography sx={{fontSize:'16px'}}>ID: {marker?.trip_details?.booking_id}</Typography>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Button
                                            variant="contained"
                                            style={{
                                                backgroundColor: '#E7F8F2',
                                                color: '#0DBA78',
                                                textTransform: 'none',
                                                pointerEvents: 'none',
                                                borderRadius: '6px',
                                                minWidth: '60px',
                                                border:'none',
                                                boxShadow: 'none',
                                                fontFamily: 'Poppins',
                                                marginRight:'16px'
                                            }}
                                        >
                                            <FiberManualRecordIcon style={{ fontSize: '14px' }}/>
                                            Active
                                        </Button>
                                    </Grid2>
                                </Grid2>
 
                                <Grid2 item sx={{backgroundColor:'#F9F9F9', display:'flex', alignItems:'center', padding:'4px 8px', borderRadius:'8px', marginTop:'2%', padding:'8px', justifyContent:'center'}}>
                                    <Typography sx={{marginRight:'4%'}}>{marker?.trip_details?.pickup_location_name}</Typography>
                                    <img src={connectAddress} alt="connect address" height="30%" width="30%" />
                                    <Typography sx={{marginLeft:'4%'}}>{marker?.trip_details?.drop_location_name}</Typography>
                                </Grid2>
 
                                <Grid2 item container sx={{padding:'2%', marginTop:'2%', alignItems:'center'}}>
                                    <Grid2 item size={1}>
                                        <img src={pickupMarker} alt="pickup marker" width="20px" height="20px" />
                                    </Grid2>
                                    <Grid2 item size={11}>
                                        <Typography sx={{color:'#83888E', fontSize:'12px'}}>Starting Point</Typography>
                                        <Typography sx={{fontSize:'14px'}}>{marker?.trip_details?.pickup_address}</Typography>
                                    </Grid2>
                                </Grid2>
                                <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB', marginLeft:'36px'}} />
 
                                <Grid2 item container sx={{padding:'2%', alignItems:'center'}}>
                                    <Grid2 item size={1}>
                                        <img src={dropMarker} alt="drop marker" width="20px" height="20px" />
                                    </Grid2>
                                    <Grid2 item size={11}>
                                        <Typography sx={{color:'#83888E', fontSize:'12px'}}>End Point</Typography>
                                        <Typography sx={{fontSize:'14px'}}>{marker?.trip_details?.drop_address}</Typography>
                                    </Grid2>
                                </Grid2>
                                <hr style={{borderTop: '1px solid #D1D5DB'}} />
 
                                <Grid2 item container sx={{marginTop:'2%', alignItems:'center'}}>
                                    <Grid2 item size={2} sx={{marginTop:'1%'}}>
                                        <img src="/truck.svg" alt="truck"/>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Typography sx={{fontSize:'12px', color:'#83888E'}}>Plate Number</Typography>
                                        <Typography sx={{color:'#4E545D', fontSize:'14px'}}>{marker?.vehicle_info?.truck_plate_no}</Typography>
                                    </Grid2>
                                    <Grid2 item size={7}>
                                        <Button sx={{border: '1px solid #0065ff', borderRadius:'10px', float:'right'}} onClick={() => moveToDetails(marker)}>
                                            <Typography sx={{textTransform:'none', color:'#0065ff'}}>View Details</Typography>
                                        </Button>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        )))
                        : (<div style={styles.errorBox}>
                            <p>No driver is online at this time.</p>
                        </div>)
                    }
                </Grid2>
 
                {!gridClickData && (
                    <Grid2 item size={7.5}>
                        <Grid2 item sx={{marginTop:'2%'}}>
                            {isLoaded && (
                                <GoogleMap 
                                    mapContainerStyle={containerStyleMain} 
                                    center={center}
                                    zoom={12} 
                                    onLoad={onLoad} 
                                    onUnmount={onUnmount}
                                >
                                    {mapViewData && mapViewData.length > 0 && mapViewData.map((marker, index) => {
                                    // console.log('here in isNearby true = ', marker)
                                        return (
                                            <Marker
                                                key={index}
                                                position={{ lat: Number(marker.driver_info?.current_latitude), lng: Number(marker.driver_info?.current_longitude) }}
                                                title={marker.driver_info?.driver_id}
                                                icon={{
                                                    url: mapPin,
                                                    scaledSize: new window.google.maps.Size(30, 30)
                                                }}
                                            />
                                        );
                                    })}
 
                                </GoogleMap>
 
                            )}
                        </Grid2>
                    </Grid2>
                )}
 
                {gridClickData && (
                    <Grid2 item size={7.8}>
                        <Grid2 item sx={{marginTop:'2%'}}>
                            {isLoaded && (
                                <GoogleMap 
                                    mapContainerStyle={containerStyleMain} 
                                    center={center}
                                    zoom={12} 
                                    onLoad={onLoad} 
                                    onUnmount={onUnmount}
                                    options={{
                                        zoomControl: true,
                                        mapTypeControl: false,
                                        streetViewControl: false,
                                        fullscreenControl: false
                                    }}
                                >
                                    {showRoute && (
                                        <>
                                            {/* Pickup Marker */}
                                            <Marker 
                                                position={{ lat: Number(gridClickData.trip_details.pickup_latitude), lng: Number(gridClickData.trip_details.pickup_longitude) }}
                                                icon={{ url: pickupMarker, scaledSize: new window.google.maps.Size(30,30) }}
                                            />
                                            {/* Drop Marker */}
                                            <Marker 
                                                position={{ lat: Number(gridClickData.trip_details.drop_latitude), lng: Number(gridClickData.trip_details.drop_longitude) }}
                                                icon={{ url: dropMarker, scaledSize: new window.google.maps.Size(30,30) }}
                                            />

                                            {/* Polyline */}
                                            {bluePath.length>1 && (
                                                <Polyline 
                                                    path={bluePath}
                                                    options={{ strokeColor:'#0065ff', strokeOpacity:1, strokeWeight:6, zIndex:1 }}
                                                />
                                            )}
                                        </>
                                     )}
                                </GoogleMap>
                            )}
                        </Grid2>
                    </Grid2>
                )}
            </Grid2>
        </div>
    )
}
 
export default ClockTower;